import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../mock';

export const FAQ = () => {
  return (
    <section id="faq" style={{
      background: '#2C3440',
      padding: '5rem 1.2rem',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Subtle Mountain Background */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.08
      }} />
      
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {/* Section Header */}
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 style={{ 
              fontFamily: "'Playfair Display', Georgia, serif",
              marginBottom: '1rem', 
              color: '#FFFFFF',
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: 700,
              fontStyle: 'italic'
            }}>Frequently Asked Questions</h2>
            <p style={{ fontFamily: "'Open Sans', sans-serif", color: '#E0E0E0', fontSize: '1.125rem' }}>
              Everything you need to know about implementing cellular restoration
            </p>
          </div>

          {/* FAQ Accordion */}
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq) => (
              <AccordionItem key={faq.id} value={`item-${faq.id}`} style={{
                borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                marginBottom: '0.5rem'
              }}>
                <AccordionTrigger style={{
                  fontFamily: "'Open Sans', sans-serif",
                  textAlign: 'left',
                  padding: '1.2rem 0',
                  color: '#FFFFFF',
                  fontWeight: 600,
                  fontSize: '1.125rem'
                }}>
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent style={{
                  fontFamily: "'Open Sans', sans-serif",
                  color: '#E0E0E0',
                  lineHeight: '1.7',
                  paddingBottom: '1.2rem',
                  fontSize: '1rem'
                }}>
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
